import {
  jiffyForBusinesses,
  jiffyForCouriers,
  jiffyForYou,
} from "../../../utils/data";
import JiffyForSection from "../../common/JiffyForSection";
import { BusinessesOfferings } from "../BusinessesOfferings";
import { RightCustomers } from "../RightCustomers";
import { Testimonials } from "../Testimonial";

const Body = () => {
  return (
    <>
      <JiffyForSection {...jiffyForCouriers} name="For Courier" />
      <RightCustomers />
      <JiffyForSection {...jiffyForBusinesses} name="For Business" />
      <BusinessesOfferings />
      <JiffyForSection {...jiffyForYou} name="For you" />
      <Testimonials />
    </>
  );
};

export default Body;
